import { useEffect, useState } from "react";
import CheckMarkIcon from "../Icons/CheckMarkIcon";
import CloseIcon from "../Icons/CloseIcon";
import s from "./CopyNotif.module.scss";
import clsx from "clsx";

interface Props {
   id: number;
   onRemove: (id: number) => void;
}

const CopyNotif: React.FC<Props> = ({ id, onRemove }) => {
   const [visible, setVisible] = useState(true);

   useEffect(() => {
      const timer = setTimeout(() => {
         setVisible(false);
      }, 4000);

      return () => {
         clearTimeout(timer);
      };
   }, [id]);

   useEffect(() => {
      if (!visible) {
         onRemove(id);
      }
   }, [visible, id, onRemove]);

   return (
      <div className={clsx(s.wrapper, { [s.hidden]: !visible })}>
         <div className={s.info}>
            <div className={s.icon}>
               <svg className={s.icon_circleChart} viewBox="0 0 36 36">
                  <path className={s.icon_circleBackground}
                     d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831"/>
                  <path className={s.icon_circleProgress}
                     d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831"/>
               </svg>
               <div className={s.icon_inner}>
                  <CheckMarkIcon />
               </div>
            </div>
            <div className={s.content}>
               <div className={s.title}>Copied</div>
               <div className={s.text}>The text was successfully copied to the clipboard</div>
            </div>
         </div>
         <div className={s.close} onClick={() => {
            onRemove(id);
         }}>
            <CloseIcon />
         </div>
      </div>
   );
}

export default CopyNotif;
